<ng-template>
  <ng-container *ngFor="let action of columns">
    <ng-container *ngTemplateOutlet="action.content"> </ng-container>
  </ng-container>
</ng-template>
